import ViewClientAllocation from './ViewClientAllocation';

export default ViewClientAllocation;
